export const AgentComparativeSales = {
    "sections": [
      {
        "columns": 12,
        "rows": 2,
        "visual": {
          "id": 1,
          "type": "advancedTable",
          "colorTheme": "colorTheme1",
          "title": "Comparative Monthly Sales",
          "binding": {
            "data": {
              "columns": [
                {
                  "name": 'Product Group',
                  "columnName": 'ItemGroupCode',
                  "width": '150px',
                  "align": "left",
                  "sortable": true,
                  "sum": false
                },
                {
                  "name": 'Jan',
                  "columnName": 'Jan',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Feb',
                  "columnName": 'Feb',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Mar',
                  "columnName": 'Mar',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Apr',
                  "columnName": 'Apr',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'May',
                  "columnName": 'May',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Jun',
                  "columnName": 'Jun',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Jul',
                  "columnName": 'Jul',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Aug',
                  "columnName": 'Aug',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Sep',
                  "columnName": 'Sep',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Oct',
                  "columnName": 'Oct',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Nov',
                  "columnName": 'Nov',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Dec',
                  "columnName": 'Dec',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Total Sales',
                  "columnName": 'TotalSales',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                }
              ],
              "title": 'DistributorName',
              "endpoint": "T13",
              "parameters": [
                { "key": "FromMonth", "value": "2024" },
                { "key": "FromYear", "value": "1" },
                { "key": "ToMonth", "value": "2024" },
                { "key": "ToYear", "value": "1" },
                { "key": "AgentCode", "value": "" },
                { "key": "ConfigTypeCode", "value": "" }
              ]
            },
            "context": {
              "point": {
                "onClick": {
                  "selectedValueColumn": "ItemGroupCode",
                  "visuals": [
                    {
                      "title": "PESO",
                      "visual": [
                        {
                          "columns": 12,
                          "rows": 2,
                          "visual": {
                            "id": 1,
                            "type": "advancedTable",
                            "colorTheme": "colorTheme1",
                            "title": "PESO",
                            "binding": {
                              "data": {
                                "columns": [
                                  {
                                    "name": 'Product Group',
                                    "columnName": 'ItemGroupCode',
                                    "width": '150px',
                                    "align": "left",
                                    "sortable": true,
                                    "sum": false
                                  },
                                  {
                                    "name": 'Jan',
                                    "columnName": 'Jan',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  },
                                  {
                                    "name": 'Feb',
                                    "columnName": 'Feb',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  },
                                  {
                                    "name": 'Mar',
                                    "columnName": 'Mar',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  },
                                  {
                                    "name": 'Apr',
                                    "columnName": 'Apr',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  },
                                  {
                                    "name": 'May',
                                    "columnName": 'May',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  },
                                  {
                                    "name": 'Jun',
                                    "columnName": 'Jun',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  },
                                  {
                                    "name": 'Jul',
                                    "columnName": 'Jul',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  },
                                  {
                                    "name": 'Aug',
                                    "columnName": 'Aug',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  },
                                  {
                                    "name": 'Sep',
                                    "columnName": 'Sep',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  },
                                  {
                                    "name": 'Oct',
                                    "columnName": 'Oct',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  },
                                  {
                                    "name": 'Nov',
                                    "columnName": 'Nov',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  },
                                  {
                                    "name": 'Dec',
                                    "columnName": 'Dec',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  },
                                  {
                                    "name": 'Total Sales',
                                    "columnName": 'TotalSales',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  }
                                ],
                                "title": 'ItemGroupCode',
                                "endpoint": "T13.1",
                                "parameters": [
                                  { "key": "FromMonth", "value": "2024" },
                                  { "key": "FromYear", "value": "1" },
                                  { "key": "ToMonth", "value": "2024" },
                                  { "key": "ToYear", "value": "1" },
                                  { "key": "ItemGroupCode", "value": "" },
                                  { "key": "AgentCode", "value": "" },
                                  { "key": "ConfigTypeCode", "value": "" }
                                ]
                              },
                              "context": {
                                "point": {
                                  "onClick": {
                                    "selectedValueColumn": "ItemGroupCode",
                                    "visuals": [
                                      {
                                        "title": "Product",
                                        "visual": [
                                          {
                                            "columns": 12,
                                            "rows": 2,
                                            "visual": {
                                              "id": 1,
                                              "type": "advancedTable",
                                              "colorTheme": "colorTheme1",
                                              "title": "Product",
                                              "binding": {
                                                "data": {
                                                  "columns": [
                                                    {
                                                      "name": 'Product Name',
                                                      "columnName": 'ItemName',
                                                      "width": '200px',
                                                      "align": "left",
                                                      "sortable": true,
                                                      "sum": false
                                                    },
                                                    {
                                                      "name": 'Jan',
                                                      "columnName": 'Jan',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": true
                                                    },
                                                    {
                                                      "name": 'Feb',
                                                      "columnName": 'Feb',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": true
                                                    },
                                                    {
                                                      "name": 'Mar',
                                                      "columnName": 'Mar',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": true
                                                    },
                                                    {
                                                      "name": 'Apr',
                                                      "columnName": 'Apr',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": true
                                                    },
                                                    {
                                                      "name": 'May',
                                                      "columnName": 'May',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": true
                                                    },
                                                    {
                                                      "name": 'Jun',
                                                      "columnName": 'Jun',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": true
                                                    },
                                                    {
                                                      "name": 'Jul',
                                                      "columnName": 'Jul',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": true
                                                    },
                                                    {
                                                      "name": 'Aug',
                                                      "columnName": 'Aug',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": true
                                                    },
                                                    {
                                                      "name": 'Sep',
                                                      "columnName": 'Sep',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": true
                                                    },
                                                    {
                                                      "name": 'Oct',
                                                      "columnName": 'Oct',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": true
                                                    },
                                                    {
                                                      "name": 'Nov',
                                                      "columnName": 'Nov',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": true
                                                    },
                                                    {
                                                      "name": 'Dec',
                                                      "columnName": 'Dec',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": true
                                                    },
                                                    {
                                                      "name": 'Total Sales',
                                                      "columnName": 'TotalSales',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                      "sum": true
                                                    }
                                                  ],
                                                  "title": 'ItemName',
                                                  "endpoint": "T13.5",
                                                  "parameters": [
                                                    { "key": "FromMonth", "value": "2024" },
                                                    { "key": "FromYear", "value": "1" },
                                                    { "key": "ToMonth", "value": "2024" },
                                                    { "key": "ToYear", "value": "1" },
                                                    { "key": "ItemGroupCode", "value": "" },
                                                    { "key": "AgentCode", "value": "" },
                                                    { "key": "ConfigTypeCode", "value": "" }
                                                  ]
                                                },
                                                "context": {
                                                  "point": {
                                                    "onClick": {
  
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                }
                              }
                            }
                          }
                        }
                      ]
                    },
                    {
                      "title": "UNIT",
                      "visual": [
                        {
                          "columns": 12,
                          "rows": 2,
                          "visual": {
                            "id": 1,
                            "type": "advancedTable",
                            "colorTheme": "colorTheme1",
                            "title": "UNIT",
                            "binding": {
                              "data": {
                                "columns": [
                                  {
                                    "name": 'Product Group',
                                    "columnName": 'ItemGroupCode',
                                    "width": '150px',
                                    "align": "left",
                                    "sortable": true,
                                  }
                                ],
                                "title": 'ItemGroupCode',
                                "endpoint": "T13.2",
                                "parameters": [
                                  { "key": "FromMonth", "value": "2024" },
                                  { "key": "FromYear", "value": "1" },
                                  { "key": "ToMonth", "value": "2024" },
                                  { "key": "ToYear", "value": "1" },
                                  { "key": "ItemGroupCode", "value": "" },
                                  { "key": "AgentCode", "value": "" },
                                  { "key": "ConfigTypeCode", "value": "" }
                                ]
                              },
                              "context": {
                                "point": {
                                  "onClick": {
                                    "selectedValueColumn": "ItemGroupCode",
                                    "visuals": [
                                      {
                                        "title": "Product",
                                        "visual": [
                                          {
                                            "columns": 12,
                                            "rows": 2,
                                            "visual": {
                                              "id": 1,
                                              "type": "advancedTable",
                                              "colorTheme": "colorTheme1",
                                              "title": "Product",
                                              "binding": {
                                                "data": {
                                                  "columns": [
                                                    {
                                                      "name": 'Product Name',
                                                      "columnName": 'ItemName',
                                                      "width": '200px',
                                                      "align": "left",
                                                      "sortable": true,
                                                    },
                                                    {
                                                      "name": 'Jan',
                                                      "columnName": 'Jan',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                    },
                                                    {
                                                      "name": 'Feb',
                                                      "columnName": 'Feb',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                    },
                                                    {
                                                      "name": 'Mar',
                                                      "columnName": 'Mar',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                    },
                                                    {
                                                      "name": 'Apr',
                                                      "columnName": 'Apr',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                    },
                                                    {
                                                      "name": 'May',
                                                      "columnName": 'May',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                    },
                                                    {
                                                      "name": 'Jun',
                                                      "columnName": 'Jun',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                    },
                                                    {
                                                      "name": 'Jul',
                                                      "columnName": 'Jul',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                    },
                                                    {
                                                      "name": 'Aug',
                                                      "columnName": 'Aug',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                    },
                                                    {
                                                      "name": 'Sep',
                                                      "columnName": 'Sep',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                    },
                                                    {
                                                      "name": 'Oct',
                                                      "columnName": 'Oct',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                    },
                                                    {
                                                      "name": 'Nov',
                                                      "columnName": 'Nov',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                    },
                                                    {
                                                      "name": 'Dec',
                                                      "columnName": 'Dec',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                    },
                                                    {
                                                      "name": 'Total Sales',
                                                      "columnName": 'TotalSales',
                                                      "width": '125px',
                                                      "align": "right",
                                                      "sortable": true,
                                                    }
                                                  ],
                                                  "title": 'ItemName',
                                                  "endpoint": "T13.6",
                                                  "parameters": [
                                                    { "key": "FromMonth", "value": "2024" },
                                                    { "key": "FromYear", "value": "1" },
                                                    { "key": "ToMonth", "value": "2024" },
                                                    { "key": "ToYear", "value": "1" },
                                                    { "key": "ItemGroupCode", "value": "" },
                                                    { "key": "AgentCode", "value": "" },
                                                    { "key": "ConfigTypeCode", "value": "" }
                                                  ]
                                                },
                                                "context": {
                                                  "point": {
                                                    "onClick": {
  
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                }
                              }
                            }
                          }
                        }
                      ]
                    }
                  ]
  
                }
              }
            }
          }
        }
      },
      {
        "columns": 12,
        "rows": 2,
        "visual": {
          "id": 1,
          "type": "advancedTable",
          "colorTheme": "colorTheme1",
          "title": "Comparative Monthly Sales (Drugstore Chains)",
          "binding": {
            "data": {
              "columns": [
                {
                  "name": 'Channel',
                  "columnName": 'DistributorCode',
                  "width": '200px',
                  "align": "left",
                  "sortable": true,
                  "sum": false
                },
                {
                  "name": 'Jan',
                  "columnName": 'Jan',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Feb',
                  "columnName": 'Feb',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Mar',
                  "columnName": 'Mar',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Apr',
                  "columnName": 'Apr',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'May',
                  "columnName": 'May',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Jun',
                  "columnName": 'Jun',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Jul',
                  "columnName": 'Jul',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Aug',
                  "columnName": 'Aug',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Sep',
                  "columnName": 'Sep',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Oct',
                  "columnName": 'Oct',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Nov',
                  "columnName": 'Nov',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Dec',
                  "columnName": 'Dec',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Total Sales',
                  "columnName": 'TotalSales',
                  "width": '125px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                }
              ],
              "title": 'CustomerGroup',
              "endpoint": "T14",
              "parameters": [
                { "key": "FromMonth", "value": "2024" },
                { "key": "FromYear", "value": "1" },
                { "key": "ToMonth", "value": "2024" },
                { "key": "ToYear", "value": "1" },
                { "key": "AgentCode", "value": "" },
                { "key": "ConfigTypeCode", "value": "" }
              ]
            },
            "context": {
              "point": {
                "onClick": {
                  "selectedValueColumn": "DistributorCode",
                  "visuals": [
                    {
                      "title": "PESO",
                      "visual": [
                        {
                          "columns": 12,
                          "rows": 2,
                          "visual": {
                            "id": 1,
                            "type": "advancedTable",
                            "colorTheme": "colorTheme1",
                            "title": "Product",
                            "binding": {
                              "data": {
                                "columns": [
                                  {
                                    "name": 'Product Name',
                                    "columnName": 'ItemName',
                                    "width": '200px',
                                    "align": "left",
                                    "sortable": true,
                                    "sum": false
                                  },
                                  {
                                    "name": 'Jan',
                                    "columnName": 'Jan',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  },
                                  {
                                    "name": 'Feb',
                                    "columnName": 'Feb',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  },
                                  {
                                    "name": 'Mar',
                                    "columnName": 'Mar',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  },
                                  {
                                    "name": 'Apr',
                                    "columnName": 'Apr',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  },
                                  {
                                    "name": 'May',
                                    "columnName": 'May',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  },
                                  {
                                    "name": 'Jun',
                                    "columnName": 'Jun',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  },
                                  {
                                    "name": 'Jul',
                                    "columnName": 'Jul',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  },
                                  {
                                    "name": 'Aug',
                                    "columnName": 'Aug',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  },
                                  {
                                    "name": 'Sep',
                                    "columnName": 'Sep',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  },
                                  {
                                    "name": 'Oct',
                                    "columnName": 'Oct',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  },
                                  {
                                    "name": 'Nov',
                                    "columnName": 'Nov',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  },
                                  {
                                    "name": 'Dec',
                                    "columnName": 'Dec',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  },
                                  {
                                    "name": 'Total Sales',
                                    "columnName": 'TotalSales',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  }
                                ],
                                "title": 'ItemName',
                                "endpoint": "T14.2",
                                "parameters": [
                                  { "key": "FromMonth", "value": "2024" },
                                  { "key": "FromYear", "value": "1" },
                                  { "key": "ToMonth", "value": "2024" },
                                  { "key": "ToYear", "value": "1" },
                                  { "key": "DistributorCode", "value": "" },
                                  { "key": "AgentCode", "value": "" },
                                  { "key": "ConfigTypeCode", "value": "" }
                                ]
                              },
                              "context": {
                                "point": {
                                  "onClick": {
  
                                  }
                                }
                              }
                            }
                          }
                        }
                      ]
                    },
                    {
                      "title": "UNIT",
                      "visual": [
                        {
                          "columns": 12,
                          "rows": 2,
                          "visual": {
                            "id": 1,
                            "type": "advancedTable",
                            "colorTheme": "colorTheme1",
                            "title": "Product",
                            "binding": {
                              "data": {
                                "columns": [
                                  {
                                    "name": 'Product Name',
                                    "columnName": 'ItemName',
                                    "width": '200px',
                                    "align": "left",
                                    "sortable": true,
                                  },
                                  {
                                    "name": 'Jan',
                                    "columnName": 'Jan',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                  },
                                  {
                                    "name": 'Feb',
                                    "columnName": 'Feb',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                  },
                                  {
                                    "name": 'Mar',
                                    "columnName": 'Mar',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                  },
                                  {
                                    "name": 'Apr',
                                    "columnName": 'Apr',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                  },
                                  {
                                    "name": 'May',
                                    "columnName": 'May',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                  },
                                  {
                                    "name": 'Jun',
                                    "columnName": 'Jun',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                  },
                                  {
                                    "name": 'Jul',
                                    "columnName": 'Jul',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                  },
                                  {
                                    "name": 'Aug',
                                    "columnName": 'Aug',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                  },
                                  {
                                    "name": 'Sep',
                                    "columnName": 'Sep',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                  },
                                  {
                                    "name": 'Oct',
                                    "columnName": 'Oct',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                  },
                                  {
                                    "name": 'Nov',
                                    "columnName": 'Nov',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                  },
                                  {
                                    "name": 'Dec',
                                    "columnName": 'Dec',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                  },
                                  {
                                    "name": 'Total Sales',
                                    "columnName": 'TotalSales',
                                    "width": '125px',
                                    "align": "right",
                                    "sortable": true,
                                  }
                                ],
                                "title": 'ItemName',
                                "endpoint": "T14.3",
                                "parameters": [
                                  { "key": "FromMonth", "value": "2024" },
                                  { "key": "FromYear", "value": "1" },
                                  { "key": "ToMonth", "value": "2024" },
                                  { "key": "ToYear", "value": "1" },
                                  { "key": "DistributorCode", "value": "" },
                                  { "key": "AgentCode", "value": "" },
                                  { "key": "ConfigTypeCode", "value": "" }
                                ]
                              },
                              "context": {
                                "point": {
                                  "onClick": {
  
                                  }
                                }
                              }
                            }
                          }
                        }
                      ]
                    }
                  ]
                }
              }
            }
          }
        }
      },
      {
        "columns": 12,
        "rows": 2,
        "visual": {
          "id": 1,
          "type": "advancedTable",
          "colorTheme": "colorTheme1",
          "title": "Product Sales Growth & Performance",
          "binding": {
            "data": {
              "columns": [
                {
                  "name": 'Product Name',
                  "columnName": 'ItemName',
                  "width": '250px',
                  "align": "left",
                  "sortable": true,
                  "sum": false
                },
                {
                  "name": 'Sales (PESO)',
                  "columnName": 'ActualSales(Value)',
                  "width": '140px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'LYSales (PESO)',
                  "columnName": 'LYSales(Value)',
                  "width": '150px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": '% Growth (PESO)',
                  "columnName": 'Growth(Value)',
                  "width": '170px',
                  "align": "right",
                  "sortable": true,
                  "sum": false,
                  "percent": true
                },
                {
                  "name": 'Target (PESO)',
                  "columnName": 'TargetSales(Value)',
                  "width": '170px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": '% Performance (PESO)',
                  "columnName": 'Performance(Value)',
                  "width": '210px',
                  "align": "right",
                  "sortable": true,
                  "sum": false,
                  "percent": true
                },
                {
                  "name": 'Sales (UNIT)',
                  "columnName": 'ActualSales(Qty)',
                  "width": '140px',
                  "align": "right",
                  "sortable": true
                },
                {
                  "name": 'LYSales (UNIT)',
                  "columnName": 'LYSales(Qty)',
                  "width": '150px',
                  "align": "right",
                  "sortable": true
                },
                {
                  "name": '% Growth (UNIT)',
                  "columnName": 'Growth(Qty)',
                  "width": '170px',
                  "align": "right",
                  "sortable": true,
                  "sum": false,
                  "percent": true
                },
                {
                  "name": 'Target (UNIT)',
                  "columnName": 'TargetSales(Qty)',
                  "width": '170px',
                  "align": "right",
                  "sortable": true,
                  "sum": false
                },
                {
                  "name": '% Performance (UNIT)',
                  "columnName": 'Performance(Qty)',
                  "width": '210px',
                  "align": "right",
                  "sortable": true,
                  "sum": false,
                  "percent": true
                }
              ],
              "title": 'ItemName',
              "endpoint": "T06",
              "parameters": [
                { "key": "FromMonth", "value": "2024" },
                { "key": "FromYear", "value": "1" },
                { "key": "ToMonth", "value": "2024" },
                { "key": "ToYear", "value": "1" },
                { "key": "AgentCode", "value": "" },
                { "key": "ConfigTypeCode", "value": "" }
              ]
            },
            "context": {
              "point": {
                "onClick": {
                  "selectedValueColumn": "ItemName",
                  "visuals": [
                    {
                      "title": "Region",
                      "visual": [
                        {
                          "columns": 12,
                          "rows": 2,
                          "visual": {
                            "id": 1,
                            "type": "advancedTable",
                            "colorTheme": "colorTheme1",
                            "title": "Region",
                            "binding": {
                              "data": {
                                "columns": [
                                  {
                                    "name": 'Region',
                                    "columnName": 'RegionCode',
                                    "width": '250px',
                                    "align": "left",
                                    "sortable": true,
                                    "sum": false
                                  },
                                  {
                                    "name": 'Sales (PESO)',
                                    "columnName": 'ActualSales(Value)',
                                    "width": '140px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  },
                                  {
                                    "name": 'LYSales (PESO)',
                                    "columnName": 'LYSales(Value)',
                                    "width": '150px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  },
                                  {
                                    "name": '% Growth (PESO)',
                                    "columnName": 'Growth(Value)',
                                    "width": '170px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": false,
                                    "percent": true
                                  },
                                  {
                                    "name": 'Target (PESO)',
                                    "columnName": 'TargetSales(Value)',
                                    "width": '170px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  },
                                  {
                                    "name": '% Performance (PESO)',
                                    "columnName": 'Performance(Value)',
                                    "width": '210px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": false,
                                    "percent": true
                                  },
                                  {
                                    "name": 'Sales (UNIT)',
                                    "columnName": 'ActualSales(Qty)',
                                    "width": '140px',
                                    "align": "right",
                                    "sortable": true
                                  },
                                  {
                                    "name": 'LYSales (UNIT)',
                                    "columnName": 'LYSales(Qty)',
                                    "width": '150px',
                                    "align": "right",
                                    "sortable": true
                                  },
                                  {
                                    "name": '% Growth (UNIT)',
                                    "columnName": 'Growth(Qty)',
                                    "width": '170px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": false,
                                    "percent": true
                                  },
                                  {
                                    "name": 'Target (UNIT)',
                                    "columnName": 'TargetSales(Qty)',
                                    "width": '170px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": false
                                  },
                                  {
                                    "name": '% Performance (UNIT)',
                                    "columnName": 'Performance(Qty)',
                                    "width": '210px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": false,
                                    "percent": true
                                  }
                                ],
                                "title": 'RegionCode',
                                "endpoint": "T06.1",
                                "parameters": [
                                  { "key": "FromMonth", "value": "2024" },
                                  { "key": "FromYear", "value": "1" },
                                  { "key": "ToMonth", "value": "2024" },
                                  { "key": "ToYear", "value": "1" },
                                  { "key": "AgentCode", "value": "" },
                                  { "key": "ItemName", "value": "" },
                                  { "key": "ConfigTypeCode", "value": "" }
                                ]
                              },
                              "context": {
                                "point": {
                                  "onClick": {
  
                                  }
                                }
                              }
                            }
                          }
                        }
                      ]
                    }
                  ]
                }
              }
            }
          }
        }
      },
      {
        "columns": 12,
        "rows": 2,
        "visual": {
          "id": 1,
          "type": "advancedTable",
          "colorTheme": "colorTheme1",
          "title": "Product Sales by Channel (PESO)",
          "binding": {
            "data": {
              "columns": [
                {
                  "name": 'Channel',
                  "columnName": 'DistributorCode',
                  "width": '150px',
                  "align": "left",
                  "sortable": true,
                  "sum": false
                },
                {
                  "name": 'Sales (PESO)',
                  "columnName": 'ActualSales(Value)',
                  "width": '140px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'LYSales (PESO)',
                  "columnName": 'LYSales(Value)',
                  "width": '150px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": '% Growth (PESO)',
                  "columnName": 'Growth(Value)',
                  "width": '170px',
                  "align": "right",
                  "sortable": true,
                  "sum": false,
                  "percent": true
                },
                {
                  "name": 'Sales (UNIT)',
                  "columnName": 'ActualSales(Qty)',
                  "width": '140px',
                  "align": "right",
                  "sortable": true
                },
                {
                  "name": 'LYSales (UNIT)',
                  "columnName": 'LYSales(Qty)',
                  "width": '150px',
                  "align": "right",
                  "sortable": true
                },
                {
                  "name": '% Growth (UNIT)',
                  "columnName": 'Growth(Qty)',
                  "width": '170px',
                  "align": "right",
                  "sortable": true,
                  "sum": false,
                  "percent": true
                }
              ],
              "title": 'DistributorName',
              "endpoint": "T15",
              "parameters": [
                { "key": "FromMonth", "value": "2024" },
                { "key": "FromYear", "value": "1" },
                { "key": "ToMonth", "value": "2024" },
                { "key": "ToYear", "value": "1" },
                { "key": "AgentCode", "value": "" },
                { "key": "ConfigTypeCode", "value": "" }
              ]
            },
            "context": {
              "point": {
                "onClick": {
                  "selectedValueColumn": "DistributorCode",
                  "visuals": [
                    {
                      "title": "Product",
                      "visual": [
                        {
                          "columns": 12,
                          "rows": 2,
                          "visual": {
                            "id": 1,
                            "type": "advancedTable",
                            "colorTheme": "colorTheme1",
                            "title": "Product",
                            "binding": {
                              "data": {
                                "columns": [
                                  {
                                    "name": 'Product Name',
                                    "columnName": 'ItemName',
                                    "width": '250px',
                                    "align": "left",
                                    "sortable": true,
                                    "sum": false
                                  },
                                  {
                                    "name": 'Sales (PESO)',
                                    "columnName": 'ActualSales(Value)',
                                    "width": '140px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  },
                                  {
                                    "name": 'LYSales (PESO)',
                                    "columnName": 'LYSales(Value)',
                                    "width": '150px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  },
                                  {
                                    "name": '% Growth (PESO)',
                                    "columnName": 'Growth(Value)',
                                    "width": '170px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": false,
                                    "percent": true
                                  },
                                  {
                                    "name": 'Sales (UNIT)',
                                    "columnName": 'ActualSales(Qty)',
                                    "width": '140px',
                                    "align": "right",
                                    "sortable": true
                                  },
                                  {
                                    "name": 'LYSales (UNIT)',
                                    "columnName": 'LYSales(Qty)',
                                    "width": '150px',
                                    "align": "right",
                                    "sortable": true
                                  },
                                  {
                                    "name": '% Growth (UNIT)',
                                    "columnName": 'Growth(Qty)',
                                    "width": '170px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": false,
                                    "percent": true
                                  }
                                ],
                                "title": 'ItemName',
                                "endpoint": "T15.2",
                                "parameters": [
                                  { "key": "FromMonth", "value": "2024" },
                                  { "key": "FromYear", "value": "1" },
                                  { "key": "ToMonth", "value": "2024" },
                                  { "key": "ToYear", "value": "1" },
                                  { "key": "AgentCode", "value": "" },
                                  { "key": "DistributorCode", "value": "" },
                                  { "key": "ConfigTypeCode", "value": "" }
                                ]
                              },
                              "context": {
                                "point": {
                                  "onClick": {
  
                                  }
                                }
                              }
                            }
                          }
                        }
                      ]
                    }
                  ]
                }
              }
            }
          }
        }
      },
      {
        "columns": 12,
        "rows": 2,
        "visual": {
          "id": 1,
          "type": "advancedTable",
          "colorTheme": "colorTheme1",
          "title": "Product Sales by Customer Group (PESO)",
          "binding": {
            "data": {
              "columns": [
                {
                  "name": 'Customer Group',
                  "columnName": 'CustomerGroup',
                  "width": '300px',
                  "align": "left",
                  "sortable": true,
                  "sum": false
                },
                {
                  "name": 'Actual Sales',
                  "columnName": 'ActualSales(Value)',
                  "width": '140px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'LYSales',
                  "columnName": 'LYSales(Value)',
                  "width": '150px',
                  "align": "right",
                  "sortable": true,
                  "sum": true
                },
                {
                  "name": 'Growth %',
                  "columnName": 'Growth(Value)',
                  "width": '150px',
                  "align": "right",
                  "sortable": true,
                  "percent": true
                }
              ],
              "title": 'CustomerGroup',
              "endpoint": "T16",
              "parameters": [
                { "key": "FromMonth", "value": "2024" },
                { "key": "FromYear", "value": "1" },
                { "key": "ToMonth", "value": "2024" },
                { "key": "ToYear", "value": "1" },
                { "key": "AgentCode", "value": "" },
                { "key": "ConfigTypeCode", "value": "" }
              ]
            },
            "context": {
              "point": {
                "onClick": {
                  "selectedValueColumn": 'CustomerGroup',
                  "visuals": [
                    {
                      "title": "Product",
                      "visual": [
                        {
                          "columns": 12,
                          "rows": 2,
                          "visual": {
                            "id": 1,
                            "type": "advancedTable",
                            "colorTheme": "colorTheme1",
                            "title": "Product",
                            "binding": {
                              "data": {
                                "columns": [
                                  {
                                    "name": 'Product Name',
                                    "columnName": 'ItemName',
                                    "width": '150px',
                                    "align": "left",
                                    "sortable": true,
                                    "sum": false
                                  },
                                  {
                                    "name": 'Sales (PESO)',
                                    "columnName": 'ActualSales(Value)',
                                    "width": '140px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  },
                                  {
                                    "name": 'LYSales (PESO)',
                                    "columnName": 'LYSales(Value)',
                                    "width": '150px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": true
                                  },
                                  {
                                    "name": '% Growth (PESO)',
                                    "columnName": 'Growth(Value)',
                                    "width": '170px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": false,
                                    "percent": true
                                  },
                                  {
                                    "name": 'Sales (UNIT)',
                                    "columnName": 'ActualSales(Qty)',
                                    "width": '140px',
                                    "align": "right",
                                    "sortable": true
                                  },
                                  {
                                    "name": 'LYSales (UNIT)',
                                    "columnName": 'LYSales(Qty)',
                                    "width": '150px',
                                    "align": "right",
                                    "sortable": true
                                  },
                                  {
                                    "name": '% Growth (UNIT)',
                                    "columnName": 'Growth(Qty)',
                                    "width": '170px',
                                    "align": "right",
                                    "sortable": true,
                                    "sum": false,
                                    "percent": true
                                  }
                                ],
                                "title": 'ItemName',
                                "endpoint": "T16.2",
                                "parameters": [
                                  { "key": "FromMonth", "value": "2024" },
                                  { "key": "FromYear", "value": "1" },
                                  { "key": "ToMonth", "value": "2024" },
                                  { "key": "ToYear", "value": "1" },
                                  { "key": "AgentCode", "value": "" },
                                  { "key": "CustomerGroup", "value": "" },
                                  { "key": "ConfigTypeCode", "value": "" }
                                ]
                              },
                              "context": {
                                "point": {
                                  "onClick": {
  
                                  }
                                }
                              }
                            }
                          }
                        }
                      ]
                    }
  
                  ]
                }
              }
            }
          }
        }
      }
    ]
  }
  